// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Etink","productName":"Table_productName__YPirp"};